import React from 'react';

// Logo Microsoft des boutons « Se connecter avec Microsoft » (connexion et
// changement de mot de passe). Couleurs de la marque en tokens (tokens.css) :
// un seul exemplaire, et aucune couleur écrite en dur dans les écrans.
export default function MicrosoftLogo({ size = 20 }) {
  return (
    <svg viewBox="0 0 21 21" width={size} height={size} aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" style={{ fill: 'var(--ms-logo-rouge)' }} />
      <rect x="11" y="1" width="9" height="9" style={{ fill: 'var(--ms-logo-vert)' }} />
      <rect x="1" y="11" width="9" height="9" style={{ fill: 'var(--ms-logo-bleu)' }} />
      <rect x="11" y="11" width="9" height="9" style={{ fill: 'var(--ms-logo-jaune)' }} />
    </svg>
  );
}
